import { Head } from "@inertiajs/react";
import { ChickenProfile } from "../../components/ChickenProfile";
import { Navbar } from "../../components/Navbar";
import { Footer } from "../../components/Footer";
import { Chicken } from "../../types/Chicken";

export default function Show({profile_uuid, images, chickens, user_id}: {profile_uuid: string, images: object, chickens: Chicken[], user_id: integer}) {
  const all_chickens = [...chickens]
  let profile = null
  let extra_chickens = []

  // loop through all the chickens and filter out the one from the uri
  for (const annotation of all_chickens) {
    if (annotation.attributes.uuid === profile_uuid) {
      profile = annotation
    } else {
      extra_chickens.push(annotation)
    }
  }

  // if the uri match fails, just pull the first one as the "base" chicken
  if (profile == null) {
    profile = extra_chickens.shift()
  }

  return (
    <>
      <Head title={"Rooster Vision - "+profile.attributes.name} />
      <Navbar />
      <div className="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75">
        <div className="container relative mx-auto">
          <div className="items-center flex flex-wrap">
            <div className="w-full px-4 ml-auto mr-auto text-center">
              <div>
                <div className="w-full px-4">
                  <div className="container font-bold text-4xl text-blue-500">
                    <ChickenProfile profile={profile} images={images} chickens={extra_chickens} user_id={user_id} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
